class StaticPool {
  static actionType = '';

  static setActionType(value) {
    StaticPool.actionType = value;
  }

  static getActionType() {
    return StaticPool.actionType;
  }

}

export default StaticPool;
